import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/freight/companies/$companyId',
}).lazy(() => import('./$companyId.lazy').then((d) => d.Route))
